import AuthMenuPanel from "components/common/AuthMenuPanel";
import AuthUserBox from "components/common/AuthUserBox";
import React from "react";

const GroupLandingLeftPanel = () => {
  return (
    <div className="pnl_leftpnl hidden_mobile">
      <AuthUserBox />
      <AuthMenuPanel moduleName="group" />
    </div>
  );
};

export default GroupLandingLeftPanel;
